<div
  class="root"
  [ngClass]="{
    root_property1Hover: property1 === 'Hover',
    root_property1CheckHover: property1 === 'Check Hover'
  }"
>
  <div
    class="ellipse5144"
    [ngClass]="{
      ellipse5144_property1HoverProperty1DefaultProperty1WithoutInteraction:
        property1 === 'Hover' ||
        property1 === 'Default' ||
        property1 === 'Without interaction',
      ellipse5144_property1CheckProperty1CheckHover:
        property1 === 'Check' || property1 === 'Check Hover',
      ellipse5144_property1Disabled: property1 === 'Disabled'
    }"
  >
   <img *ngIf="property1 === 'Check'" src="../../../../../../../assets/images/green-check-circle.png" alt="">
   <img *ngIf="property1 === 'Default'" src="../../../../../../../assets/images/yellow-clock.png" alt="">
  </div>
  <app-property-1-call-state-default
    *ngIf="
      property1 === 'Hover' ||
      property1 === 'Default' ||
      property1 === 'Disabled' ||
      property1 === 'Without interaction'
    "
    [property1]="'Plus'"
    [state]="'Default'"
    class="property1CallStateDefault"
  ></app-property-1-call-state-default>
  <app-property-1-call-state-default
    *ngIf="property1 === 'Check' || property1 === 'Check Hover'"
    [property1]="'Check'"
    [state]="'Default'"
    class="property1CallStateDefault"
  ></app-property-1-call-state-default>
</div>
